import "../../main.js";
import Alpine from "../../plugins/alpine.js";

const getPathName = () => {
  const arr = location.pathname.split("/").filter((item) => !!item);
  return arr[arr.length - 1] ?? "";
};
Alpine.data("category", () => getPathName());
Alpine.data("categoryList", () => [
  {
    key: "wire-draw-dies",
    title: "Wire Draw Dies",
    link: "/product-category/wire-draw-dies",
    results: 10,
  },
  {
    key: "extrusion-tools-and-wire-guide",
    title: "Extrusion Tools And Wire Guide",
    link: "/product-category/extrusion-tools-and-wire-guide",
    results: 4,
  },
  {
    key: "nail-dies",
    title: "Nail Dies",
    link: "/product-category/nail-dies",
    image: "https://starcarbide.com/wp-content/uploads/4-1.jpg",
    results: 3,
  },
  {
    key: "tungsten-carbide-roll",
    title: "Tungsten Carbide Roll",
    link: "/product-category/tungsten-carbide-roll",
    results: 4,
  },
  {
    key: "dies-for-fasteners",
    title: "Dies for fasteners",
    link: "/product-category/dies-for-fasteners",
    results: 10,
  },
]);

const productListMap = {
  "wire-draw-dies": [
    {
      title: "ND WIRE DRAWING DIE",
      link: "/product/nd-wire-drawing-die",
      image: "/images/1、WIRE DRAW DIES/1、ND WIRE DRAWING DIE .png",
    },
    {
      title: "PCD WIRE DRAWING DIE",
      link: "/product/pcd-wire-drawing-die",
      image: "/images/1、WIRE DRAW DIES/2、PCD WIRE DRAWING DIE.png",
    },
    {
      title: "TUNGSTEN CARBIDE WIRE DRAWING DIE",
      link: "/product/tungsten-carbide-wire-drawing-die",
      image:
        "/images/1、WIRE DRAW DIES/3.TUNGSTEN CARBIDE WIRE DRAWING DIE.jpg",
    },
    {
      title: "Nano Coating Drawing Die",
      link: "/product/nano-coating-drawing-die",
      image: "/images/1、WIRE DRAW DIES/4、Nano Coating Drawing Die.png",
    },
    {
      title: "PCD Stranding Dies",
      link: "/product/pcd-stranding-dies",
      image: "/images/1、WIRE DRAW DIES/5、PCD Stranding Dies.png",
    },
    {
      title: "Sector Stranding Die",
      link: "/product/sector-stranding-die",
      image: "/images/1、WIRE DRAW DIES/6、Sector Stranding Die.png",
    },
    {
      title: "Tubing Dies",
      link: "/product/tubing-dies",
      image: "/images/1、WIRE DRAW DIES/7、Tubing Dies.png",
    },
    {
      title: "Special-shaped Dies",
      link: "/product/special-shaped-dies",
      image: "/images/1、WIRE DRAW DIES/8、Special-shaped Dies.png",
    },
    {
      title: "Split Stranding Dies",
      link: "/product/split-stranding-dies",
      image: "/images/1、WIRE DRAW DIES/9 Split Stranding Dies.png",
    },
    {
      title: "ROLLER PRESSING DIE",
      link: "/product/roller-pressing-die",
      image: "/images/1、WIRE DRAW DIES/10、ROLLER PRESSING DIE.png",
    },
  ],
  "extrusion-tools-and-wire-guide": [
    {
      title: "Extrusion Tips",
      link: "/product/extrusion-tips",
      image: "/images/2、Extrusion Tools And Wire Guide/56.png",
    },
    {
      title: "Extrusion Dies",
      link: "/product/extrusion-dies",
      image: "/images/2、Extrusion Tools And Wire Guide/extursion-dies.png",
    },
    {
      title: "Lap Joint Mold",
      link: "/product/lap-joint-mold",
      image: "/images/2、Extrusion Tools And Wire Guide/lap-joint-mold.png",
    },
    {
      title: "Spiral Diverter",
      link: "/product/spiral-diverter",
      image: "/images/2、Extrusion Tools And Wire Guide/spiral-diverter.png",
    },
  ],
  "nail-dies": [
    {
      title: "Nail cutting knife",
      link: "/product/nail-cutting-knife",
      image: "/images/4、nail dies/1、Nail cutting knife.png",
    },
    {
      title: "Nail gripper die",
      link: "/product/nail-gripper-die",
      image: "/images/4、nail dies/2、Nail gripper die.png",
    },
    {
      title: "Nail head punch",
      link: "/product/nail-head-punch",
      image: "/images/4、nail dies/3、Nail head punch.jpg",
    },
  ],
  "tungsten-carbide-roll": [
    {
      title: "Tungsten carbide roller for welded wire mesh",
      link: "/product/tungsten-carbide-roller-for-welded-wire-mesh",
      image:
        "/images/3、tungsten carbide roll/1、Tungsten carbide roller for welded wire mesh.jpg",
    },
    {
      title: "ROLLER HOLDERS AND COLLING PINS",
      link: "/product/roller-holders-and-colling-pins",
      image:
        "/images/3、tungsten carbide roll/2、ROLLER HOLDERS AND COLLING PINS.png",
    },
    {
      title: "DESCALING ROLLS",
      link: "/product/descaling-rolls",
      image: "/images/3、tungsten carbide roll/3.DESCALING ROLLS.png",
    },
    {
      title: "Seaming roller",
      link: "/product/seaming-roller",
      image: "/images/3、tungsten carbide roll/4、Seaming roller.png",
    },
  ],
  "dies-for-fasteners": [
    {
      title: "Flat Dies",
      link: "/product/flat-dies",
      image: "/images/5、Dies for fasteners/1、Flat Dies.jpg",
    },
    {
      title: "Cold heading dies",
      link: "/product/cold-heading-dies",
      image: "/images/5、Dies for fasteners/2、Cold heading dies.png",
    },
    {
      title: "Threading rolling dies",
      link: "/product/threading-rolling-dies",
      image: "/images/5、Dies for fasteners/3、Threading rolling dies.png",
    },
    {
      title: "Stamping dies",
      link: "/product/stamping-dies",
      image: "/images/5、Dies for fasteners/4、Stamping dies.png",
    },
    {
      title: "Trimming Dies",
      link: "/product/trimming-dies",
      image: "/images/5、Dies for fasteners/5、Cold Forming Trimming Die.png",
    },
    {
      title: "PUNCH CUTTER",
      link: "/product/punch-cutter",
      image: "/images/5、Dies for fasteners/6、PUNCH CUTTER.png",
    },
    {
      title: "MAIN DIES",
      link: "/product/main-dies",
      image: "/images/5、Dies for fasteners/7、MAIN DIES.png",
    },
    {
      title: "PUNCH",
      link: "/product/punch",
      image: "/images/5、Dies for fasteners/8、PUNCH.png",
    },
    {
      title: "TUNGSTEN CARBIDE DIES",
      link: "/product/tungsten-carbide-dies",
      image: "/images/5、Dies for fasteners/9、TUNGSTEN CARBIDE DIES.png",
    },
    {
      title: "Heading Dies",
      link: "/product/heading-dies",
      image: "/images/5、Dies for fasteners/10、Heading Dies.png",
    },
  ],
};

Alpine.data("productList", () => productListMap[getPathName()]);

Alpine.start();
